import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { reduxForm } from 'redux-form';
import denormalize from 'json-api-denormalizer';
import { connect } from 'react-redux';

class GenericForm extends Component {
  componentDidMount() { this.handleSuccess() }
  componentDidUpdate() { this.handleSuccess() }

  handleSuccess = ()=> {
    const { submitWasSuccessful, onSuccess } = this.props
    if(submitWasSuccessful){ onSuccess() }
  }

  childComponentProps = ()=> {
    const { formComponentProps, additionalComponentProps, onSubmitNew, onSubmitEdit, onSubmitDelete, initialValues, formData, isSubmitting, submitError, submitWasSuccessful } = this.props

    return({
      ...formComponentProps,
      ...additionalComponentProps,
      formData,
      initialValues,
      isSubmitting,
      submitError,
      submitWasSuccessful,
      onSubmitNew,
      onSubmitEdit,
      onSubmitDelete
    });
  }

  render() {
    return <div className='form-container'>{React.createElement(this.props.formComponent, this.childComponentProps())}</div>
  }
}

const { object, func, string, bool } = PropTypes;
GenericForm.propTypes = {
  formData:             object,
  initialValues:        object,
  onSubmitNew:          func,
  onSubmitEdit:         func,
  onSubmitDelete:       func,
  onSuccess:            func,
  isSubmitting:         bool,
  submitError:          string,
  submitWasSuccessfuL:  bool,
  formComponentProps:   object
}

export default GenericForm;
